import ListCard from '@Components/ListCard/ListCard';
import AdminLogServices from '@Services/AdminLog.services.ts';
import { AdminLog } from '@Types/Admin.types';
import { PaginatedResponse } from '@Types/Response.types';
import { PAGE_PROP, PAGE_SIZE, PAGINATED_DEFAULT, PATHS, TABLE_STRUCTURES } from '@Utils/constants';
import { formatAdminLogListData } from '@Utils/format.utils.tsx';
import { handleRequestError } from '@Utils/request.utils';
import { Pagination, useTopHat } from '@kg-internal/pv3-uikit';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const AdminLogs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [adminLogs, setAdminLogs] = useState<PaginatedResponse<AdminLog>>(PAGINATED_DEFAULT);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string>();
  const currentPage = Number(searchParams.get(PAGE_PROP) ?? '1');

  useTopHat({
    activeNav: 'nav-users',
    activeTab: undefined,
    tabs: [],
    breadcrumbs: [
      { title: 'Users', href: PATHS.USERS, id: 'Users' },
      {
        title: 'Admin Logs',
        href: `${PATHS.ADMIN_LOG}?page=${1}`,
        id: 'Admin Logs',
      },
    ],
  });

  useEffect(() => {
    setIsLoading(true);
    AdminLogServices.getAdminLogs(currentPage)
      .then(({ data }) => {
        setAdminLogs(data);
        setErrorMessage(undefined);
      })
      .catch((error) => {
        handleRequestError(error, setErrorMessage);
      })
      .finally(() => setIsLoading(false));
  }, [currentPage]);

  const handleNewPage = (newPage: number) => {
    if (newPage <= 0 || newPage > adminLogs.totalPages) {
      return;
    }
    searchParams.set(PAGE_PROP, newPage.toString());
    setSearchParams(searchParams);
  };

  return (
    <div className='grid'>
      <div className='col-12 col-md-12'>
        <ListCard<AdminLog>
          title={'Admin Logs'}
          structure={TABLE_STRUCTURES.ADMIN_LOG}
          data={formatAdminLogListData(adminLogs)}
          loading={isLoading}
          error={errorMessage}
        />
      </div>
      <div className='col-12 content-middle content-right-md'>
        <Pagination
          count={adminLogs.totalDocs}
          perPage={PAGE_SIZE}
          currentPage={currentPage - 1}
          onChange={(page) => handleNewPage(page + 1)}
        />
      </div>
    </div>
  );
};

export default AdminLogs;
